import { useContext } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type * as API from '@trinity/chat/api/interfaces/projects';
import { TagStateContext } from '@/screens/Project.Tags/Context';
import { indexBy } from '@trinity/chat-components';

type MutationParams = API.DeleteProjectTag.Request;

export const useDeleteTagMutation = () => {
  const { dispatch } = useContext(TagStateContext);

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: ['delete:projects/tags'],
    mutationFn: (data: MutationParams) => {
      return apiClient.projects.deleteProjectTag(data);
    },
    onSuccess: (res: API.DeleteProjectTag.Response, params: MutationParams) => {
      dispatch({
        type: 'remove-tag',
        projectTagId: params.tagId,
      });
      dispatch({
        type: 'update-ordinals',
        ordinals: indexBy(res.rebalancedOrdinals, k => k.id, v => v.ordinal),
      });
    },
  });
};